import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chevron-down-icon',
  templateUrl: 'chevron-down-icon.component.html'
})
export class ChevronDownIconComponent {
  constructor() {}
}
